'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _Nav = require('components/Nav/Nav');

var _Nav2 = _interopRequireDefault(_Nav);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _HomeLanding = require('./HomeLanding.scss');

var _HomeLanding2 = _interopRequireDefault(_HomeLanding);

var _reactIntl = require('react-intl');

var _Link = require('components/Link/Link');

var _Link2 = _interopRequireDefault(_Link);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _search = require('redux/modules/search');

var _customize = require('redux/modules/customize');

var _HomeSearch = require('./HomeSearch');

var _HomeSearch2 = _interopRequireDefault(_HomeSearch);

var _helpers = require('utils/helpers.js');

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  HomeLanding: {
    displayName: 'HomeLanding'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Home/HomeLanding.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import FontAwesome from 'react-fontawesome';

// import { searchLog } from 'redux/modules/session';


// import CustomSelect from 'components/General/FormElements/CustomSelect';
// import Calendar from 'containers/Calendar/Calendar';

// import _ from 'lodash';
// import Scroll from 'react-scroll';
// const ScrollLink = Scroll.Link;


_momentTimezone2.default.tz.setDefault('Asia/Bangkok');

var HomeLanding = _wrapComponent('HomeLanding')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    destinations: state.info.destinations,
    loading: state.loader.loading,
    // isOpenMobileQuickSearch: state.session.openMobileQuickSearch,
    userConfig: state.info.userConfig,
    siteConfigs: state.info.siteConfigs,
    messages: state.language.messages,
    locale: state.language.locale,
    groupDestinationsByCountry: state.info.siteConfigs.groupDestinationsByCountry,
    tourType: state.session.tourType
  };
}, (0, _extends3.default)({}, _reactRouterRedux.routerActions, { setLastTripId: _search.setLastTripId, logCustomizeTrip: _customize.logCustomizeTrip })), _dec2 = (0, _reactCssModules2.default)(_HomeLanding2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(HomeLanding, _Component);

  function HomeLanding(props) {
    (0, _classCallCheck3.default)(this, HomeLanding);

    // this.onChangePath = this.onChangePath.bind(this);
    var _this = (0, _possibleConstructorReturn3.default)(this, (HomeLanding.__proto__ || (0, _getPrototypeOf2.default)(HomeLanding)).call(this, props));

    _this.state = {
      mounted: false,
      showVideo: false,
      destination: '',
      date: null,
      showDatePicker: false,
      guest: null
    };
    _this.openCustomizeTrip = _this.openCustomizeTrip.bind(_this);
    // this.onChangeDestination = this.onChangeDestination.bind(this);
    // this.onChangeDate = this.onChangeDate.bind(this);
    // this.toggleDatePicker = this.toggleDatePicker.bind(this);
    // this.search = this.search.bind(this);

    if (!(typeof _this.openCustomizeTrip === 'function')) {
      throw new TypeError('Value of "this.openCustomizeTrip" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.openCustomizeTrip));
    }

    return _this;
  }

  (0, _createClass3.default)(HomeLanding, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.setState({ mounted: true }); // eslint-disable-line
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 700) {
        this.setState({ showVideo: false }); // eslint-disable-line
      } else {
        this.setState({ showVideo: true }); // eslint-disable-line
        this.timeout = setTimeout(function () {
          _this2.refs.video.play();
        }, 4000);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
    }
    // onChangePath(e) {
    //   e.target.blur();
    //   if (this.props.userConfig.tourTypeEnabled) {
    //     if (!this.props.tourType) {
    //       this.props.push(`/tour${e.target.value && `?location=${e.target.value}`}`);
    //     } else {
    //       this.props.push(`/to/${e.target.value || 'Any'}${`?tags=${this.props.tourType}`}`);
    //     }
    //   } else if (this.props.userConfig.preActivitiesEnabled) {
    //     this.props.push(`/activity${e.target.value && `?location=${e.target.value}`}`);
    //   } else {
    //     this.props.setLastTripId(); // clear back behavior
    //     this.props.push(`/to/${e.target.value || 'Any'}?sort=Recommended`);
    //   }
    // }
    // onChangeDestination(e) {
    //   e.target.blur();
    //   this.setState({destination: e.target.value}, ()=> {
    //     if (this.state.date) {
    //       this.search();
    //     }
    //   });
    //   // if (!this.state.date) {
    //   //   this.setState({showDatePicker: true});
    //   // }
    // }
    // onChangeDate(date) {
    //   this.setState({date, showDatePicker: false}, ()=> {
    //     if (this.state.destination) {
    //       this.search();
    //     }
    //   });
    // }
    // toggleDatePicker() {
    //   this.setState({showDatePicker: !this.state.showDatePicker});
    // }
    // search() {
    //   const {destination, date} = this.state;
    //   this.props.push(`/to/${destination || 'Any'}${date ? `?date=${date}` : ''}`);
    // }
    // getOptions = () => {
    //   const {messages} = this.props;
    //   const popular = [];
    //   const cities = [];
    //   Object.keys(this.props.destinations).map((key) => {
    //     this.props.destinations[key].map((city) => {
    //       if (city.city !== 'Bangkok') {
    //         if (city.popular) {
    //           popular.push({label: city.city, value: city.city});
    //         } else {
    //           cities.push({label: city.city, value: city.city});
    //         }
    //       }
    //     });
    //   });
    //   // popular.sort();
    //   // cities.sort();
    //   return [
    //     {label: messages['nav.select_dropdown.dropdown_placeholder.popular_cities'], options: [{label: 'Bangkok', value: 'Bangkok'}, ..._.sortBy(popular, 'label')]},
    //     {label: messages['nav.select_dropdown.dropdown_placeholder.cities'], options: _.sortBy(cities, 'label')}
    //   ];
    // }

  }, {
    key: 'openCustomizeTrip',
    value: function openCustomizeTrip() {
      this.props.logCustomizeTrip();
    }
  }, {
    key: 'render',
    value: function render() {
      // const {destination, date, showVideo, showDatePicker} = this.state;
      var showVideo = this.state.showVideo;
      // const destinations = this.getOptions();
      // const activitiesCriteria = true;
      // const {messages, loading, locale, siteConfigs} = this.props;

      var _props = this.props,
          loading = _props.loading,
          locale = _props.locale,
          siteConfigs = _props.siteConfigs;

      var desktopImage = require('theme/images/desktop-background.jpg');
      var pachantiewDesktopImage = require('theme/images/pachantiew-desktop-background.jpg');
      var instantUrl = (0, _helpers.getInstantUrl)();
      return _react3.default.createElement(
        'div',
        {
          styleName: function () {
            if (loading) return 'container-loading';
            if (locale === 'th') return 'container-pachantiew';
            return 'container';
          }()
        },
        _react3.default.createElement(_Nav2.default, { white: true }),
        _react3.default.createElement(
          'div',
          { styleName: 'footage' },
          showVideo && _react3.default.createElement(
            'video',
            { ref: 'video', loop: 'loop', preload: 'auto', poster: locale === 'th' ? pachantiewDesktopImage : desktopImage },
            locale !== 'th' && _react3.default.createElement('source', { src: 'https://d2ad32w75yf016.cloudfront.net/HomePage_Footage.webm', type: 'video/webm' }),
            _react3.default.createElement('source', { src: locale === 'th' ? 'https://d2ad32w75yf016.cloudfront.net/Footage_PaChanTiew.mp4' : 'https://d2ad32w75yf016.cloudfront.net/HomePage_Footage.mp4', type: 'video/mp4' })
          )
        ),
        _react3.default.createElement(
          'h1',
          { styleName: 'headline' },
          _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.home_landing.tagline', values: { lineBreak: _react3.default.createElement('br', null) } })
        ),
        _react3.default.createElement(
          'h2',
          { styleName: 'sub-headline' },
          _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.home_landing.sub_tagline' })
        ),
        !siteConfigs.removeSearchFeature && _react3.default.createElement(_HomeSearch2.default, (0, _extends3.default)({}, this.props, { styles: undefined })),
        siteConfigs.searchScrollToInspiration && _react3.default.createElement(
          'div',
          { styleName: 'dropdown-select-container', onClick: function onClick() {
              return document.getElementById('see-inspirations').scrollIntoView();
            } },
          _react3.default.createElement(
            'div',
            { styleName: 'dropdown-select' },
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'nav.select_dropdown.dropdown_placeholder' }),
            _react3.default.createElement('div', { styleName: 'dropdown-arrow' })
          )
        ),
        _react3.default.createElement(
          'p',
          { styleName: 'customize-link' },
          _react3.default.createElement(
            _Link2.default,
            { to: '/customize', onClick: this.openCustomizeTrip },
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.home_landing.customize_link' })
          ),
          instantUrl && siteConfigs.instantEnabled && _react3.default.createElement(
            'span',
            { styleName: 'vertical-divider' },
            '|'
          ),
          instantUrl && siteConfigs.instantEnabled && _react3.default.createElement(
            _Link2.default,
            { to: instantUrl },
            _react3.default.createElement('i', { styleName: 'instant-icon' }),
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.home_landing.instant_booking' })
          )
        )
      );
    }
  }]);
  return HomeLanding;
}(_react2.Component), _class2.propTypes = {
  destinations: _react2.PropTypes.array,
  // push: PropTypes.func,
  loading: _react2.PropTypes.bool,
  // isOpenMobileQuickSearch: PropTypes.bool,
  // openMobileQuickSearch: PropTypes.func,
  userConfig: _react2.PropTypes.object,
  setLastTripId: _react2.PropTypes.func,
  logCustomizeTrip: _react2.PropTypes.func,
  messages: _react2.PropTypes.object,
  locale: _react2.PropTypes.string,
  siteConfigs: _react2.PropTypes.object,
  tourType: _react2.PropTypes.string,
  groupDestinationsByCountry: _react2.PropTypes.bool
}, _class2.defaultProps = {
  destinations: {}
}, _temp)) || _class) || _class));

exports.default = HomeLanding;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/HomeLanding.js
// module id = 1530
// module chunks = 47